import Badge from "./badge";
import CloseImage from "../../assets/images/close.svg";

function SeeAllBadgesModal(props) {
    return (
        <div className="modal-container">
            <div className="see-all-modal">
                <div className="see-all-modal-header">
                    <div className="left">
                        <p className="badge-section-name">
                            {props.section && props.section.name ? props.section.name : null}
                            {props.section.counts && props.section.counts.total && props.section.counts.earned && props.section.counts.earned > 0 ?
                                <span className="badge-section-earned-count">
                                    {`(${props.section.counts.earned} of ${props.section.counts.total} Earned)`}
                                </span> : <></>
                            }
                        </p>
                    </div>
                    <div className="right">
                        <button onClick={props.close} className="close">
                            <img alt="close" className="flex-grow-0 flex-shrink-0 cursor-pointer" src={CloseImage}
                                style={{ width: "32px", height: "32px", float: "right" }}/>
                        </button>
                    </div>
                </div>
                <div className="badge-section-desc">
                    {props.section && props.section.desc ? props.section.desc : null}
                </div>
                <div className="see-all-modal-body">
                    <div className="see-all-badge-container">
                        {props.section.badges.map((badge, j) => <Badge badge={badge} key={j} />)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SeeAllBadgesModal;